var map = {
	"./buy-course-bg.png": 213,
	"./choose-level-bg.png": 622,
	"./close-icon.png": 214,
	"./row.png": 215
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 621;


//////////////////
// WEBPACK FOOTER
// ./src/components/dialog/static/img ^\.\/.*\.png$
// module id = 621
// module chunks = 1